export default function MapSection() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Find Us</h2>
          <p className="text-lg text-gray-600">
            Located in Radnor, Pennsylvania - Serving the Greater Philadelphia Area
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="w-full h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.4447891234567!2d-75.4394648!3d40.0437773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6c0c0c0c0c0c0%3A0x0!2s201%20King%20of%20Prussia%20Rd%20Suite%20650%2C%20Wayne%2C%20PA%2019089!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="KaliKare Homecare Office Location"
            ></iframe>
          </div>
          
          <div className="p-8 bg-gradient-to-r from-purple-700 to-purple-800 text-white">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="text-center md:text-left">
                <h3 className="text-2xl font-bold mb-2">Need Directions?</h3>
                <p className="text-white/90">We're conveniently located in Radnor, PA</p>
              </div>
              <a
                href="https://www.google.com/maps/dir//201+King+of+Prussia+Rd+Suite+650,+Wayne,+PA+19089/@40.0437773,-75.4394648,12z"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-purple-700 px-8 py-4 rounded-lg font-semibold hover:bg-purple-50 transition-colors text-base whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <i className="fas fa-directions"></i>
                Get Directions
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}